import React from 'react';

const Home = () => {
  return (
    <main className='mx-auto p-4'>
      <div className='bg-[#134463] text-white p-4 rounded-lg'>
        <h3><b>Welcome to our DashBoard</b></h3>
        <p>To get started use the links on your left.</p>
      </div>
    </main>
  );
};

export default Home;
